<template>
    <div class="SubscriptionMsg .main-1440">

        <!-- type="flex" justify="center" -->
        <el-row>
            <el-col class="SubscriptionMsgTitle" :xs="24" :sm="24">订阅HICOOL最新资讯</el-col>

            <el-col class="SubscriptionMsgTitleAfter hidden-xs-only" :offset="11" :xs="2" :sm="2"></el-col>
            <el-col class="SubscriptionMsgTitleAfter hidden-sm-and-up" :offset="7" :xs="10" :sm="2"></el-col>

            <el-row :xs="24" :sm="24" class="SubscriptionMsgSubmit" type="flex" justify="center">
                <el-col :xs="16" :sm="10" class="SubscriptionMsgInput">
                    <input style="overflow: hidden;" v-model="mail" type="text" placeholder="请输入订阅Email地址">
                </el-col>
                <el-col :xs="8" :sm="2" class="SubscriptionMsgButton">
                    <div @click="submitEmail()">
                        提 交
                    </div>
                </el-col>
            </el-row>


            <!-- <el-col :xs="12" :sm="12" class="SubscriptionMsgInput">
            <input type="text" placeholder="请输入订阅Email地址">
        </el-col>
        <el-col :xs="12" :sm="12" class="SubscriptionMsgButton">提交</el-col> -->
        </el-row>

    </div>
</template>

<script>
    import axios from "axios"
    import Qs from "qs"
    export default {
        props: {},
        components: {},
        data() {
            return {
                mail: ''
            }
        },
        created: function () {


        },
        methods: {
            submitEmail() {
                let self = this;
                //用户提交的邮箱
                let data = Qs.stringify({ mail: self.mail });
                console.log('submitEmail-点击事件');
                axios.post('/api/jointsubscription',data)
                    .then(function (response) {
                        if (response.data.code == 0) {

                            alert('提交成功！')

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .SubscriptionMsg .SubscriptionMsgSubmit {
            margin-left: 5px;
            margin-right: 5px;

        }
    }

    .SubscriptionMsg {
        margin-top: 40px;
        background-image: url('../../../../public/static/images/SubscriptionMsg-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        text-align: center;

    }

    .SubscriptionMsgTitle {
        margin-top: 40px;

        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;

    }

    .SubscriptionMsgTitleAfter {
        content: "";

        display: block;
        /* width: 126px; */
        height: 11px;
        background-color: #00ffff;
        border-radius: 4px;
        margin-top: 23px;
    }

    .SubscriptionMsgSubmit {
        margin-top: 166px;
        padding-bottom: 88px;
    }

    .SubscriptionMsgInput {

        background-color: #f7f7f8;
        border-radius: 8px 0px 0px 8px;
    }

    .SubscriptionMsgInput input {
        width: 100%;
        outline: none;
        border: none;
        padding: 24px 24px;
        padding-right: 0;
        text-align: left;

        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        background-color: #f7f7f8;
        border-radius: 8px 0px 0px 8px;
    }

    .SubscriptionMsgButton {
        padding: 23px 0;
        background-color: #f957fd;
        border-radius: 0px 8px 8px 0px;

        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        cursor: pointer;

    }

    /*修改提示文字的颜色*/

    input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #b7b7b7 !important;
    }

    input::-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #b7b7b7 !important;
    }

    input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #b7b7b7 !important;
    }

    input::-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #b7b7b7 !important;
    }
</style>